import {
  START_CART_LOADING,
  CLEAR_CART,
  ADD_ITEM,
  REMOVE_ITEM,
  UPDATE_QUANTITY_ITEM,
  SET_CART,
  ERROR_CART,
  OPEN_CART,
  CLOSE_CART,
  CHECK_CART,
  EXPORT_CART_START_LOADING,
  EXPORT_CART_END_LOADING,
  MODAL_CART_ERROR,
  RESET_MODAL_ERROR,
  RESET_MODAL_CLEAR_CART,
  MODAL_CLEAR_CART
} from "../type";
import {
  clearLocalStorage,
  getIdCampaign,
  getLocalStore,
  setLocalStorage
} from "../../helper/utility";
import * as services from "../../services/grocery_list.services";
import { checkCart as productCheckCart } from "../../services/product.services";
import { NotificationManager } from "react-notifications";
import { serverResponse } from "../../util/fakeServer";
import { setGlobalError } from "../error/action";
import { store } from "../store";

export const getCart = () => async (dispatch) => {
  dispatch({
    type: START_CART_LOADING
  });

  try {
    const localStore = getLocalStore();
    services
      .getCart({ id_param_url: localStore })
      .then((res) => {
        const { data } = res;
        if (data) {
          dispatch({
            type: SET_CART,
            payload: data.data
          });
        }
      })
      .catch((err) => {
        if (err) {
          dispatch(setGlobalError(err.response));
          clearLocalStorage();
        }
      });
  } catch (error) {
    dispatch({
      type: ERROR_CART,
      payload: error
    });
  }
};

export const toggleCart = (cartState) => (dispatch) => {
  if (cartState)
    dispatch({
      type: CLOSE_CART
    });
  else
    dispatch({
      type: OPEN_CART
    });
};

export const checkCartValidity = () => (dispatch) => {
  const userGrocery = getLocalStore();
  let valid = false;
  if (!userGrocery || userGrocery === undefined || userGrocery === "") {
    dispatch({
      type: CLEAR_CART
    });
    dispatch({
      type: MODAL_CART_ERROR
    });
  } else {
    valid = true;
  }
  return valid;
};

export const clearCart = () => (dispatch) => {
  const isValid = dispatch(checkCartValidity());
  if (isValid) {
    dispatch({ type: MODAL_CLEAR_CART });
  }
};

export const actionClearCart = () => (dispatch) => {
  try {
    const localStore = getLocalStore();

    clearLocalStorage();
    services
      .clearCart({ id_param_url: localStore })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: CLEAR_CART
          });
          clearLocalStorage();
        }
      })
      .catch((err) => {
        if (err) {
          dispatch(setGlobalError(err.response));
          clearLocalStorage();
        }
      });
  } catch (error) {
    dispatch({
      type: ERROR_CART,
      payload: error
    });
    NotificationManager.error("Riprova più tardi", "Errore", 1200);
  }
};

export const removeItem = (skul) => (dispatch) => {
  const isValid = dispatch(checkCartValidity());

  if (isValid) {
    try {
      const localStore = getLocalStore();
      services
        .removeItem({ id_param_url: localStore, skul })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.data.length === 0) {
              clearLocalStorage();
            }
            dispatch({
              type: REMOVE_ITEM,
              payload: skul
            });
          }
        })
        .catch((err) => {
          dispatch(setGlobalError(err.response));
        });
    } catch (error) {
      NotificationManager.error("Errore", "Riprova più tardi", 1200);
    }
  }
};

export const updateQuantityItem = (skul, type, callback) => (dispatch) => {
  const isValid = dispatch(checkCartValidity());

  if (isValid) {
    try {
      const localStore = getLocalStore();
      services
        .updateQuantity({ id_param_url: localStore, skul, type })
        .then((res) => {
          const { data } = res;

          if (data) {
            if (data.data.length === 0) {
              dispatch({
                type: REMOVE_ITEM,
                payload: skul
              });
              const {
                cartReducer: { cart }
              } = store.getState();
              if (cart.length === 0) {
                clearLocalStorage();
              }
            } else {
              dispatch({ type: UPDATE_QUANTITY_ITEM, payload: data.data[0] });
            }
          }
        })
        .catch((err) => {
          if (err) {
            dispatch(setGlobalError(err.response));
            console.log(err.response.data.code);
            if (err.response.data.code === 400) {
              clearLocalStorage();
            } else {
              dispatch(removeItem(skul));
            }
          }
        })
        .finally(() => callback(false));
    } catch (error) {
      dispatch({
        type: ERROR_CART,
        payload: error
      });
      NotificationManager.error("Riprova più tardi", "Errore", 1200);
    }
  }
};

export const addItem = (item) => (dispatch) => {
  try {
    let localStore = getLocalStore();
    let isNewId = false;
    if (!localStore) {
      localStore = setLocalStorage();
      isNewId = true;
    }
    const id_campaign = getIdCampaign();
    services
      .addItem({
        id_param_url: localStore,
        item: item,
        id_campaign: id_campaign,
        flyer_url: serverResponse.config.shareFlyerURL
      })
      .then((res) => {
        const { data } = res;
        if (data) {
          dispatch({
            type: ADD_ITEM,
            payload: data
          });
          NotificationManager.success(
            "Controlla il tuo carrello",
            "Prodotto aggiunto con successo",
            1000
          );
        }
      })
      .catch((err) => {
        dispatch(setGlobalError(err.response));
        if (isNewId) clearLocalStorage();
      });
  } catch (error) {
    NotificationManager.error("Riprova più tardi", "Errore", 1200);
  }
};

export const checkCart = (callback) => (dispatch) => {
  const isValid = dispatch(checkCartValidity());

  if (isValid) {
    try {
      let localStore = getLocalStore();
      productCheckCart({
        id_param_url: localStore,
        id_listino: serverResponse.config.id_listino
      })
        .then((res) => {
          const { data } = res;
          if (data) {
            dispatch({
              type: CHECK_CART,
              payload: data.data[0]
            });
            let updated = false;
            let counter = 0;

            while (!updated && counter < data.data[0].length) {
              if (data.data[0][counter].updated) updated = true;

              counter++;
            }

            callback(updated);
          }
        })
        .catch((err) => {
          dispatch(setGlobalError(err.response));
          clearLocalStorage();
        });
    } catch (error) {
      console.log(error);
    }
  }
};

export const toggleExportLoader = (cartState) => (dispatch) => {
  if (cartState)
    dispatch({
      type: EXPORT_CART_START_LOADING
    });
  else
    dispatch({
      type: EXPORT_CART_END_LOADING
    });
};

export const resetModalError = () => (dispatch) => {
  dispatch({
    type: RESET_MODAL_ERROR
  });
};

export const resetModalClearCart = () => (dispatch) => {
  dispatch({
    type: RESET_MODAL_CLEAR_CART
  });
};
